<input type="search" [(ngModel)]="gridFilter.filterValue" maxlength="7000" class="form-control" style="display: inline; margin-right: 5px; width: 20%" (keydown.enter)="enterKeyPressHandler()" trimOnBlur>
<button (click)="editFilter()" style="position:relative; top:-1px">Edit</button>

<app-modal-basic #modalEditFilter id="modalEditFilter">
  <div class="app-modal-header modal-padding">
    <h6 class="modal-title">Edit advanced report filter</h6>
  </div>
  <div class="app-modal-body modal-padding">
    <table style="width:100%">
      <tr id="validationMsgFilter" style="display: none">
        <td></td>
        <td style="color: red; white-space: pre-wrap" id="validationErrorTdFilter">
          Fields marked with * cannot be blank
        </td>
      </tr>
      <tr>
        <td nowrap>Condition *&nbsp;</td>
        <td style="padding-bottom: 5px">
          <select id="selectCondition" class="form-control" (change)='onConditionSelected()' [(ngModel)]="conditionNo" style="width: 350px; margin-right: 50px">
            <option value="1">Donor gave at least X contributions</option>
            <option value="2">Donor gave a total of at least $</option>
            <option value="3">Donor gave a contribution of at least $</option>
            <option value="4">Donor gave a total of at least $X each year</option>
            <option value="5">Donor gave a total of at least $X each month</option>
            <option value="6">Donor gave a total of less than $X each year</option>
            <option value="7">Donor gave a total of less than $X each month</option>
            <option value="8">Donor gave a contribution of type</option>
            <option value="9">Donor gave toward designation</option>
            <option value="10">Donor gave toward ledger account</option>
            <option value="11" [hidden]="leadershipUser">Donor is</option>
            <option value="12" [hidden]="leadershipUser">Donor first name begins with</option>
            <option value="13" [hidden]="leadershipUser">Donor last name begins with</option>
            <option value="14">Donor state is</option>
          </select>
        </td>
        <td rowspan="10">
          <textarea type="text" [(ngModel)]="newFilterValue" maxlength="7000" class="form-control" style="width: 370px; height: 310px; resize: none" trimOnBlur></textarea>
        </td>
      </tr>
      <tr>
        <td nowrap>Value *&nbsp;</td>
        <td style="padding-bottom: 5px">
          <input type="text" [(ngModel)]="conditionValue" [hidden]="conditionNo > 7" maxlength="20" class="currency-input form-control" style="width: 100px" trimOnBlur data-not-blank mask="separator.2" thousandSeparator="," [dropSpecialCharacters]="true">
          <input type="text" [(ngModel)]="conditionValue2" [hidden]="conditionNo > 13 || conditionNo < 12" maxlength="20" class="currency-input form-control" style="width: 100px" trimOnBlur data-not-blank>
          <ng-select [items]="conditionValueOptions" [(ngModel)]="conditionValueSelected" [hidden]="conditionNo < 8 || conditionNo == 9 || conditionNo == 12 || conditionNo == 13" [multiple]="true" [closeOnSelect]="false" style="width: 350px; margin-right: 50px" data-not-blank></ng-select>
          <designation-chooser #desChooser [hidden]="conditionNo != 9" style="margin-right: 10px"></designation-chooser>
        </td>
      </tr>
      <tr>
        <td nowrap>Not (inverse)&nbsp;</td>
        <td style="padding-bottom: 5px">
          <input type="checkbox" [(ngModel)]="notCondition" class="big-checkbox">
        </td>
      </tr>
      <tr [hidden]="!showDateRange">
        <td nowrap>In date range&nbsp;</td>
        <td style="height: 40px">
          <span style="white-space: nowrap; ">
            <input type="date" id="fromDateField" [ngModel]="fromDate | date:'yyyy-MM-dd'" (ngModelChange)="fromDate = $event" maxlength="45" class="form-control" style="display: inline; width: 157px" trimOnBlur>
            To
            <input type="date" id="toDateField" [ngModel]="toDate | date:'yyyy-MM-dd'" (ngModelChange)="toDate = $event" maxlength="45" class="form-control" style="display: inline; width: 157px" trimOnBlur>
          </span>
        </td>
      </tr>
      <tr>
        <td nowrap></td>
        <td style="padding-top: 10px">
          <button (click)="addCondition(true)" style="position:relative; top:-1px">Add condition{{newFilterValue.trim() == '' ? '' : ' with AND'}}</button>&nbsp;&nbsp;
          <button (click)="addCondition(false)" style="position:relative; top:-1px" [hidden]="newFilterValue.trim() == ''">Add condition with OR</button>
        </td>
      </tr>
      <tr>
        <td nowrap>&nbsp;</td>
      </tr>
      <tr>
        <td nowrap>&nbsp;</td>
      </tr>
      <tr>
        <td nowrap>&nbsp;</td>
      </tr>
      <tr>
        <td nowrap>&nbsp;</td>
      </tr>
    </table>

  </div>
  <div class="app-modal-footer modal-padding">
    <button type="button" class="btn btn-primary btn-modal" (click)="validateFilter()" style="width:120px">Validate</button>
    &nbsp;
    <button type="button" class="btn btn-primary btn-modal" (click)="finishEditFilter()">Apply</button>
    &nbsp;
    <button type="button" class="btn btn-default btn-modal" (click)="modalEditFilter.hide()">Cancel</button>
  </div>
</app-modal-basic>
